module.exports = __webpack_public_path__ + "img/sentosa-wave-orange.dcf8573f.svg";